export const environment = {
  production: true,
  firebaseAPIKey: 'AIzaSyBp2IVZk1kqZQkTIIHNXwB7fZAXRmsMHMQ',
  AirtableAPIKey: 'keym5oOY0ed6XbWcj',
  AirtableBASEKey: 'appUsg4WcPjVw256G',
  AirtableUSERKey: '',
};
